import { z } from "zod";
import { ColumnSchema, ViewSchema } from "./views";

export enum ClientColumn {
    NAME = "name",
    ENTITIES = "entities",
    TEAM = "team",
}

export enum ClientSortValue {
    NAME_ASC = "NAME_ASC",
    NAME_DESC = "NAME_DESC",
}

const NameColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.NAME),
});
export type NameColumn = z.infer<typeof NameColumnSchema>;

const EntitiesColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.ENTITIES),
});
export type EntitiesColumn = z.infer<typeof EntitiesColumnSchema>;

const TeamColumnSchema = ColumnSchema.extend({
    id: z.literal(ClientColumn.TEAM),
});
export type TeamColumn = z.infer<typeof TeamColumnSchema>;

export const ClientViewSchema = ViewSchema.extend({
    type: z.literal("client"),
    columns: z.array(
        z.discriminatedUnion("id", [
            NameColumnSchema,
            EntitiesColumnSchema,
            TeamColumnSchema,
        ]),
    ),
});

export type ClientView = z.infer<typeof ClientViewSchema>;
